import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, Pager, Webhook, WebhookService } from 'lib-trend-core';
import { Observable, takeUntil } from 'rxjs';
import { WebhookMessageViewComponent } from './webhook-message-view/webhook-message-view.component';
import { WebhookViewComponent } from './webhook-view/webhook-view.component';

@Component({
    selector: 'webhook-component',
    templateUrl: 'webhook.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebhookComponent extends AbstractComponent implements OnInit {

  pager: Pager<Webhook> = new Pager<Webhook>({ perPage: 25, total: 0 });
  listObservable: Observable<Pager<Webhook>>;

  constructor(
    public injector: Injector,
    public dialog: MatDialog,
    public webhookService: WebhookService) {
    super(injector);
  }

  ngOnInit() {
  }

  getList() {
    this.loadingContent = true;
    this.webhookService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (pager: Pager<Webhook>) => {
          this.pager = pager;
        },
        error: (err) => {
          this.loadingContent = false;
          this.alertService.error(err?.error?.message ?? 'Não foi possível carregar os webhooks.');
        },
        complete: () => (this.loadingContent = false),
      });
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  search(channel: string, from: string, messageId: string) {
    this.pager.page = 1;
    // only send filled filters: an empty/unselected control used to travel as the literal
    // string "undefined" in the query string and matched no document at all
    this.searchParams = {};
    if (!!channel) {
      this.searchParams.channel = channel;
    }
    if (!!from?.trim()) {
      this.searchParams.from = from.trim();
    }
    if (!!messageId?.trim()) {
      this.searchParams.messageId = messageId.trim();
    }
    this.getList();
  }

  view(webhook: Webhook) {
    this.dialog.open(WebhookViewComponent, {
      width: '1000px',
      height: '800px',
      data: webhook
    });
  }

  viewMessage(messageId: string) {
    if (!!messageId) {
      this.dialog.open(WebhookMessageViewComponent, {
        width: '1000px',
        height: '800px',
        data: messageId
      });
    }
  }

}
